module.exports = __webpack_public_path__ + "img/hr-green-croton-01.cc094b74.png";